"use client";

import * as React from "react";
import { MessageSquare } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
export default function FloatingWhatsAppButton() {
  return <section data-section-id="247684" id="whatsappquickcontact" className="bg-background text-foreground">
      <TooltipProvider>
        <Tooltip delayDuration={300}>
          <TooltipTrigger asChild>
            <Button asChild className="fixed bottom-6 right-6 z-50 size-14 rounded-full bg-accent text-primary shadow-lg shadow-accent/40 hover:bg-accent/90 hover:scale-[1.02] transition-all duration-300 p-4 border border-white/20 animate-pulse ring-accent/50 backdrop-blur-md" aria-label="تواصل معنا عبر واتساب">
              <Link to="https://wa.me/966505276652" newTab>
                <MessageSquare className="size-7 stroke-[1.5px]" />
              </Link>
            </Button>
          </TooltipTrigger>
          <TooltipContent side="left" className="mr-2 bg-secondary/80 backdrop-blur-xl text-white border border-white/10 shadow-2xl rounded-lg px-4 py-2">
            <p className="font-primary text-sm font-bold">تواصل معنا الآن</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </section>;
}